// eslint-disable-next-line import/prefer-default-export
export const MENU_ITEM_ICON_TYPE_ARROW = 'arrow'
